import { React, useContext, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/SectorFilter";
import StageFilter from "../../Components/RefineSearchComponents/StageFilter";
import RoundFilter from "../../Components/RefineSearchComponents/RoundFilter";
import CompanyTypeFilter from "../../Components/RefineSearchComponents/CompanyTypeFilter";
import YearFoundedFilter from "../../Components/RefineSearchComponents/YearFoundedFilter";
import DealTypeFilter from "../../Components/RefineSearchComponents/DealTypeFilter";
import SyndicationFilter from "../../Components/RefineSearchComponents/SyndicationFilter";
import DealsInvolvingFilter from "../../Components/RefineSearchComponents/DealsInvolvingFilter";
import CountryFilter from "../../Components/RefineSearchComponents/CountryFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import StateFilter from "../../Components/RefineSearchComponents/StateFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import InvestorHeadquartersFilter from "../../Components/RefineSearchComponents/InvestorHeadquartersFilter";
import DealRangeFilter from "../../Components/RefineSearchComponents/DealRangeFilter";
import ExitStatusFilter from "../../Components/RefineSearchComponents/ExitStatusFilter";
import ValuationFilter from "../../Components/RefineSearchComponents/ValuationFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import axios from "axios";
import { filterLocationUrl, filterSectorByIndutry, tagList, tagSearchUrl } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { FaInfoCircle } from "react-icons/fa"
import { Modal, Tooltip } from "antd";
import DefinitionModal from "../TagDefinitionModal";
import useModule from "../../hooks/useModule";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

/**
 * The component renders a form for refining search filters.
 * @returns a JSX element.
 */
export default function LimitedPartnerRefineSearch({ customPathname, menu }) {
    const {
        dbDropdown , setDbDropdown ,isMobile,
        onErrorHandler,open,setOpen,
        refineSearchFilters,SwitchState,setSwitchState,dropdown,Sectors, setSectors,
        InvestorOptions , setInvestorOptions ,dealsView,checkToggleBtn,setToggleDealsBtn,
        lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,AllCities,
        setrefineSearchFilters ,setMonthPickerValue ,HeadquarterCityOptions,setHeadquarterCityOptions,selectedInvestorHeadquartersCity,setSelectedInvestorHeadquartersCity} = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(21);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false
    const isFromGroupList =()=> refineSearchFilters[location.pathname]?.myList?.length > 0 ? true : false


    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [StageOptions, setStageOptions] = useState([])
    const [RoundOptions, setRoundOptions] = useState([])
    const [CompanyTypeOptions, setCompanyTypeOptions] = useState([])
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [StartYearOptions, setStartYearOptions] = useState([])
    const [DealTypeOption, setDealTypeOption] = useState([]);
    const [SyndicationOptions, setSyndicationOptions] = useState([])
    const [DealsInvolvingOptions, setDealsInvolvingOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [HeadquartersOptions, setHeadquartersOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [DealRange, setDealRange] = useState({ from: "", to: "" })
    const [ExitStatusOptions, setExitStatusOptions] = useState([])
    const [ValuationOptions, setValuationOptions] = useState([])
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getLPFiltersCount = () => {
        let count = 0;
        if (FirmTypeOptions?.length > 0 && FirmTypeOptions.some(option => option.isChecked)) count++;
        if (CityOptions?.length > 0 && CityOptions.some(option => option.isChecked)) count++;
        if (CountryOptions?.length > 0 && CountryOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (lAdvisorsOptions?.length > 0 && lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (InvestorOptions?.length > 0 && InvestorOptions.some(option => option.isChecked)) count++;
        return count;
    };


    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = Sectors.filter(option => option.isChecked);
        const selectedStages = StageOptions.filter(option => option.isChecked);
        const selectedRounds = RoundOptions.filter(option => option.isChecked);
        const selectedCompanyType = CompanyTypeOptions?.filter(option => option.isChecked);
        const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedDealType = DealTypeOption?.filter(option => option.isChecked);
        const selectedSynd = SyndicationOptions?.filter(option => option.isChecked);
        const selectedDealInvolving = DealsInvolvingOptions?.filter(option => option.isChecked);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedHeadCity = HeadquarterCityOptions?.filter(option => option.isChecked);
        const selectedHead = HeadquartersOptions?.filter(option => option.isChecked);
        const selectedHeadNames = selectedHeadCity.map(option => option.name);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedExitStatus = ExitStatusOptions?.filter(option => option.isChecked);
        const selectedValuations = ValuationOptions?.filter(option => option.isChecked);
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        
        checkToggleBtn();
        setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked));
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                stage: selectedStages,
                round: selectedRounds,
                companyType: selectedCompanyType,
                yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
                dealType: selectedDealType,
                syndication: selectedSynd,
                dealsInvolving: selectedDealInvolving,
                countries: selectedCountries,
                region: selectedRegion,
                investor_headquaters_city: selectedHeadCity,
                state: selectedState,
                city: selectedCity,
                investorType: selectedInvestorType,
                investorHeadquarters: selectedHead,
                firmType: selectedFirm,
                dealRange: DealRange?.from != "" && DealRange?.to != "" ? [{ id: 0, name: DealRange?.from }, { id: 1, name: DealRange?.to }] : [],
                exitStatus: selectedExitStatus,
                valuations: selectedValuations,
                operator: TagSwitchState ? 1 : 0,
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
                tags: TagsOptions,
                // myList:isFromGroupList()? Object.keys(refineSearchFilters[location.pathname] ?? {}).map((filter) => {
                //     let tagList = [];
                //     tagList = refineSearchFilters[location.pathname][filter];
                //     return [{id:0,name:tagList?.name, group_id:tagList?.group_id}]

                // }):null

            },
        }))
    }

    const resetDealsByFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
        setHeadquarterCityOptions(HeadquarterCityOptions.map(option => {
            if (option.isChecked) {
                return { ...option, isChecked: false };
            }
            return option;
        }));
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
        setSectors([]);
        setToggleDealsBtn(true);
    }

    useEffect(()=>{
        setToggleDealsBtn(true);
    },[customPathname])



 console.log(InvestorOptions , "jjjij")
    // Submitting Refine Search Form 
    const refineSearchFilter = (event) => {
        if(isMobile){
            setOpen(!open);
        }
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null || isCompanyMatch != null) {
        //     navigate(routeNames.pe_companies_pe_vc_investments);
        // }
        applyFilter();
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        setSelected(false)

    }

    const onResetClick = (event) => {

        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null || isCompanyMatch != null) {
        //     navigate(routeNames.pe_companies_pe_vc_investments);
        // }
        resetDealsByFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val == select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onCountryChange = (options) => {
        const ids = options.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            lpcountry: ids,
            region: [],
            state: [],
            lpcity: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCountryOptions(response?.data?.LPCountries)
                setCityOptions(response?.data?.LPCities)
            }
        }).catch(onErrorHandler)
    }

    useEffect(() => {
        const lpcountry = refineSearchFilters[customPathname]?.LPCountries?.map(value => value.id) ?? [];
        const lpcity = refineSearchFilters[customPathname]?.LPCities?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            lpcountry: [],
            region: [],
            state: [],
            lpcity: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCountryOptions(response?.data?.LPCountries?.map(option => ({ ...option, isChecked: lpcountry.includes(option.id) })))
                setCityOptions(response?.data?.LPCities?.map(option => ({ ...option, isChecked: lpcity.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters,AllCities])


    const  [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})


    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-2 lg:p-3 rounded-lg transition-colors whitespace-nowrap ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 lg:gap-2">
                                            <span className="text-sm lg:text-base font-medium">Keyword Search</span>
                                            {getKeywordFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 lg:px-2 py-0.5 lg:py-1 min-w-[18px] lg:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getKeywordFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 lg:p-3 rounded-lg transition-colors whitespace-nowrap ${
                                        activeFilterSection === 'lp' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'lp' ? null : 'lp')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 lg:gap-2">
                                            <span className="text-sm lg:text-base font-medium">Limited Partner</span>
                                            {getLPFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 lg:px-2 py-0.5 lg:py-1 min-w-[18px] lg:min-w-[20px] text-center ${activeFilterSection === 'lp' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getLPFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'lp' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right column - Filters */}
                            <div className="overflow-visible mt-4 md:mt-0 pb-20 md:pb-0 md:col-span-6">
                                <div className={`w-full lg:w-2/4 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        <LAdvisor 
                                            options={lAdvisorsOptions}
                                            setOptions={setlAdvisorsOptions}
                                            customPathname={customPathname}
                                            label="Limited Partners"
                                            accordionClick={() => accordionClick(21)}
                                            open={select === 21}
                                        />
                                        <Investor 
                                            options={InvestorOptions}
                                            setOptions={setInvestorOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(32)}
                                            label="General Partner"
                                            open={select === 32}
                                        />
                                    </div>
                                </div>
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-8 ${activeFilterSection === 'lp' ? '' : 'hidden'}`}>
                                    <FirmTypeFilter
                                        FirmTypeOptions={FirmTypeOptions}
                                        setFirmTypeOptions={setFirmTypeOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(16)}
                                        dataPath="limited_partners"
                                        open={select === 16}
                                        isPopupOpen={openFilterPopup === 'firmType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                                    />
                                    <CityFilter
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(13)}
                                        open={select === 13}
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                    <CountryFilter
                                        CountryOptions={CountryOptions}
                                        setCountryOptions={setCountryOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(10)}
                                        onChange={onCountryChange}
                                        open={select === 10}
                                        isPopupOpen={openFilterPopup === 'country'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'country' : null)}
                                    />
                                </div>
                                
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal values={defValues} onClose={defCloseHandler}/>}
        </div>
    );
}

